import { render, staticRenderFns } from "./CheckProperties.vue?vue&type=template&id=1c5a8887&scoped=true"
import script from "./CheckProperties.vue?vue&type=script&lang=js"
export * from "./CheckProperties.vue?vue&type=script&lang=js"
import style0 from "./CheckProperties.vue?vue&type=style&index=0&id=1c5a8887&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a8887",
  null
  
)

export default component.exports